module.exports = __webpack_public_path__ + "img/image.5b766de6.svg";